import React from 'react';

// Components
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';

const SelectorSkeleton = () => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  const time = {
    borderRadius: 2,
    height: mdUp ? 20 : 30,
    justifySelf: mdUp ? 'end' : 'center',
    width: mdUp ? 22 : 67,
  };

  const live = {
    ...time,
    justifySelf: mdUp ? 'end' : 'initial',
  };

  return (
    <Box
      borderBottom={`1px solid ${theme.palette.graphic.light}`}
      data-testid="skeleton"
      display={mdUp ? 'grid' : 'block'}
      gridTemplateColumns="170px calc(100% - 170px)"
      p={mdUp ? '24px 24px 20px' : '16px 18px 16px 16px'}
    >
      <Skeleton
        height={20}
        sx={{ borderRadius: 2, justifySelf: 'start' }}
        variant="rectangular"
        width="100%"
      />
      <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" mt={mdUp ? 0 : 1}>
        <Skeleton sx={live} variant="rectangular" />
        <Skeleton sx={time} variant="rectangular" />
        <Skeleton sx={time} variant="rectangular" />
        <Skeleton sx={time} variant="rectangular" />
      </Box>
    </Box>
  );
};

export default SelectorSkeleton;
